// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1___5b496f21dc21410cf12","cls2":"TruncateHeight-cls2___8fec083ff57bd0478fa TruncateHeight-cls1___5b496f21dc21410cf12"};